import React from "react";
import { Badge } from "@/components/ui/badge";
import { useT } from "@/i18n/LanguageContext";
import { isWarrantyOrder, isReorderOrder, PRIORITY_TAG_CLS } from "@/lib/priority";

// Small WARRANTY / REORDER pill shown next to the PO # on every production list.
export function PriorityTag({ order, testid }) {
  const { t } = useT();
  const w = isWarrantyOrder(order);
  const r = isReorderOrder(order);
  if (!w && !r) return null;
  return (
    <>
      {w && <Badge className={PRIORITY_TAG_CLS} data-testid={`warranty-tag-${testid || order.id}`}>🛠 {t("WARRANTY")}</Badge>}
      {r && <Badge className={PRIORITY_TAG_CLS} data-testid={`reorder-tag-${testid || order.id}`}>🔁 {t("REORDER")}</Badge>}
    </>
  );
}
